import { Injectable } from '@angular/core';
import { ServerConfigService } from 'src/app/services/server-config.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { UrlBuilderService } from 'projects/communication/src/app/services/url-builder.service';

@Injectable({
  providedIn: 'root',
})
export class DrillsService {
  constructor(private http: HttpClient, private configServer: ServerConfigService, private urlBuilder: UrlBuilderService) {}

  /**
   * Function to get all drills
   */
  public getAllStatus(params: any): Observable<any> {
    const url = `${this.urlBuilder.apiUrl}/status/statusproductionbymachinetype`;
    return this.http.get(url, { params });
  }

  /**
   * Function to get the machines in fronts
   */
  public getMachinesInFront(params: any): Observable<any> {
    const url = `${this.urlBuilder.apiUrl}/status/statusproductionbyfront`;
    return this.http.get(url, { params });
  }
}
